<script setup lang="ts">
import { CopyIcon } from 'lucide-vue-next'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'pejer/src/components/ui/tooltip'
import { h } from 'vue'
import Button from '../../ui/button/Button.vue'
import { toast } from '../../ui/toast'

const props = defineProps<{
  value?: string | number | null
  alwaysVisible?: boolean
}>()

const copyToClipboard = () => {
  navigator.clipboard.writeText(String(props.value))
  toast({
    title: 'Copied to clipboard:',
    description: h('div', { class: 'sentry-mask' }, String(props.value)),
  })
}
</script>
<template>
  <div class="relative group flex items-center">
    <slot />

    <Button
      v-if="value && alwaysVisible"
      class="absolute right-0 bg-gray-50 hover:bg-gray-100 p-2 h-fit"
      @click.prevent.stop="copyToClipboard"
      variant="ghost"
    >
      <CopyIcon :size="16" />
    </Button>

    <TooltipProvider v-else-if="value">
      <Tooltip>
        <TooltipTrigger as-child>
          <Button
            class="absolute right-0 group-hover:opacity-100 bg-gray-50 h-fit hover:bg-gray-100 opacity-0 p-2 transition-opacity duration-200"
            @click.prevent.stop="copyToClipboard"
            variant="ghost"
          >
            <CopyIcon :size="16" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Copy</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>
</template>
